module.exports = __webpack_public_path__ + "static/media/Matchmind.dff491df.png";